import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

export default function CurrencyView() {
  const { id } = useParams();
  const [row, setRow] = useState(null);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/currencies/${id}`)
      .then((res) => setRow(res.data))
      .catch(() => setRow(null));
  }, [id]);

  if (!row) return getText("LOADING_TEXT");

  return (
    <div className="container card p-4 mt-3">

      <div className="mb-2">
        <strong>{getText("CURRENCY_CODE_LABEL")}:</strong> {row.code}
      </div>

      <div className="mb-2">
        <strong>{getText("CURRENCY_SYMBOL_LABEL")}:</strong> {row.symbol}
      </div>

      <div className="mb-2">
        <strong>{getText("CURRENCY_NAME_LABEL")}:</strong> {row.name}
      </div>

      <div className="mb-2">
        <strong>{getText("IS_DEFAULT_LABEL")}:</strong>{" "}
        {row.is_default === 1
          ? getText("YES_LABEL")
          : getText("NO_LABEL")}
      </div>

      <div className="mb-2">
        <strong>{getText("STATUS_LABEL")}:</strong>{" "}
        {row.status === "aktif" || row.status === 1
          ? getText("STATUS_ACTIVE")
          : getText("STATUS_PASSIVE")}
      </div>

      <div className="d-flex justify-content-center">
        <Link className="btn btn-primary" to="/currency/table">
          {getText("BACK")}
        </Link>
      </div>
    </div>
  );
}
